<script setup lang="ts">
import { useEnv } from '@library/composables'
import { useBfInjectStore } from '@library/stores'
import { isApiSuccess } from '@library/utils/functions'

const { getBfApi } = useBfInjectStore()

const apiVersion = ref<string>('')

const { VITE_APPLICATION_VERSION, VITE_APPLICATION_VERSION_MODE } = useEnv()

const version = computed(
  () => `${VITE_APPLICATION_VERSION}_api-${apiVersion.value}`
)

onMounted(async () => {
  const responseData = (await getBfApi().unAuth.getSysVersion()).data
  if (isApiSuccess(responseData)) {
    apiVersion.value = responseData.data.version
  }
})
</script>

<template>
  <span
    v-if="VITE_APPLICATION_VERSION_MODE"
    class="bf-version"
    :class="VITE_APPLICATION_VERSION_MODE"
  >
    {{ version }}
  </span>
</template>

<style lang="scss" scoped>
.bf-version {
  position: fixed;
  bottom: 10px;
  left: 10px;
  z-index: 999999;
  font-size: 12px;
  color: #666;

  &.hidden {
    display: none;
  }
}
</style>
